/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import jsonEquals from "../functions/jsonEquals";
import MarkdownEntry from "../datatypeComponents/MarkdownEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import CodeEntry from "../datatypeComponents/CodeEntry";
import StringEntry from "../datatypeComponents/StringEntry";
import ReferenceEntry from "../datatypeComponents/ReferenceEntry";
import CodeableConceptEntry from "../datatypeComponents/CodeableConceptEntry";

const documentReferenceTypeValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "statistical-analysis-plan",
            "display": "Statistical analysis plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "data-management-plan",
            "display": "Data management plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "interim-analysis-plan",
            "display": "Interim analysis plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "adverse-event-monitoring-plan",
            "display": "Adverse event monitoring plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "auditing-plan",
            "display": "Auditing plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "irb-approval",
            "display": "IRB approval"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dissemination-plan",
            "display": "Dissemination plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "consent-form",
            "display": "Consent form"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "consent-plan",
            "display": "Consent plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "confidential-personal-data-management-plan",
            "display": "Confidential personal data management plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "declaration-of-interests",
            "display": "Declaration of interests"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "data-access-plan",
            "display": "Data access plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "ancillary-care-plan",
            "display": "Ancillary care plan"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dataset",
            "display": "Dataset"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "dataset-access",
            "display": "Dataset access"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "software",
            "display": "Software"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "software-access",
            "display": "Software access"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "education",
            "display": "Education"
        }
        ]
    },
    {
        "coding": [{
            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/research-study-document-types-code-system",
            "code": "specimen-plan",
            "display": "Specimen plan"
        }
        ]
    }
];

const DocumentReferenceResourceEdit = ({ foi }) => {

    const dispatch = useDispatch();
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail)); //TODO to do. This is really bad to put here, this is for every render
    let resourceJson = newResourceDetail.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({});
    const [resourceLoaded, setResourceLoaded] = useState(false);
    const [extensionState, setExtensionState] = useState({ "otherExtensions": [], "title": "" });
    const [startingExtensionState, setStartingExtensionState] = useState({ "otherExtensions": [], "title": "" });
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useEffect(() => {
        if (resourceJson && !resourceLoaded) {
            let startingExtension = resourceJson.extension || [];
            let startingExtensionStateValue = { "otherExtensions": [], "title": resourceJson.title || "" };
            if (Array.isArray(startingExtension) && startingExtension.length > 0) {
                for (const extension of startingExtension) {
                    switch (extension.url) {
                        case 'http://hl7.org/fhir/StructureDefinition/artifact-title':
                            startingExtensionStateValue.title = extension.valueString;
                            break;
                        default:
                            startingExtensionStateValue.otherExtensions.push(extension)
                    }
                }
            }
            setExtensionState(JSON.parse(JSON.stringify(startingExtensionStateValue)));
            setStartingExtensionState(JSON.parse(JSON.stringify(startingExtensionStateValue)));
            if (!resourceJson.content || !Array.isArray(resourceJson.content) || resourceJson.content.length === 0) {
                resourceJson.content = [
                    {
                        "attachment": ""
                    }
                ]
            }
            setEditResourceState({
                extension: resourceJson.extension,
                identifier: resourceJson.identifier,
                version: resourceJson.version,
                status: resourceJson.status,
                docStatus: resourceJson.docStatus,
                type: resourceJson.type,
                category: resourceJson.category,
                subject: resourceJson.subject,
                related: resourceJson.related,
                author: resourceJson.author,
                custodian: resourceJson.custodian,
                description: resourceJson.description,
                content: resourceJson.content
            });
            if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of resourceJson.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
            setResourceLoaded(true);
        }
    }, [resourceLoaded]);

    useEffect(() => {
        if (extensionState && !jsonEquals(extensionState, startingExtensionState)) {
            let newExtension = [];
            if (extensionState.otherExtensions) {
                newExtension = JSON.parse(JSON.stringify(extensionState.otherExtensions));
            }
            if (extensionState.title) {
                newExtension.push({
                    "url": "http://hl7.org/fhir/StructureDefinition/artifact-title",
                    "valueString": extensionState.title
                });
            }
            if (!(newExtension.length > 0)) {
                newExtension = null;
            }
            if (!jsonEquals(parentResourceDetail.revisedResourceJson.extension, newExtension)) {
                let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                newResourceDetail.revisedResourceJson.extension = newExtension;
                newResourceDetail.displayTitle = extensionState.title;
                dispatch(resourceUpdated(newResourceDetail));
                //console.log("resourceUpdate for DocumentReference.extension");
            }
        }
    }, [extensionState.title]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.identifier || [];
            if (editResourceState.identifier !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.identifier)) {
                newResourceDetail.revisedResourceJson.identifier = editResourceState.identifier;
                //console.log("resourceUpdate for DocumentReference.identifier");
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.identifier]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.version;
            if (editResourceState.version !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.version) &&
                !(!previousFinalValue && !editResourceState.version)) {
                //console.log("resourceUpdate for DocumentReference.version");
                newResourceDetail.revisedResourceJson.version = editResourceState.version;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.version]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.status;
            if (editResourceState.status !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.status) &&
                !(!previousFinalValue && !editResourceState.status)) {
                //console.log("resourceUpdate for DocumentReference.status");
                newResourceDetail.revisedResourceJson.status = editResourceState.status;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.status]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.docStatus;
            if (editResourceState.docStatus !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.docStatus) &&
                !(!previousFinalValue && !editResourceState.docStatus)) {
                //console.log("resourceUpdate for DocumentReference.docStatus");
                newResourceDetail.revisedResourceJson.docStatus = editResourceState.docStatus;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.docStatus]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.type;
            if (editResourceState.type !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.type) &&
                !(!previousFinalValue && !editResourceState.type)) {
                //console.log("resourceUpdate for DocumentReference.type");
                newResourceDetail.revisedResourceJson.type = editResourceState.type;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.type]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.category;
            if (editResourceState.category !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.category) &&
                !(!previousFinalValue && !editResourceState.category)) {
                //console.log("resourceUpdate for DocumentReference.category");
                newResourceDetail.revisedResourceJson.category = editResourceState.category;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.category]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.subject;
            if (editResourceState.subject !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.subject) &&
                !(!previousFinalValue && !editResourceState.subject)) {
                //console.log("resourceUpdate for DocumentReference.subject");
                newResourceDetail.revisedResourceJson.subject = editResourceState.subject;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.subject]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.related;
            if (editResourceState.related !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.related) &&
                !(!previousFinalValue && !editResourceState.related)) {
                //console.log("resourceUpdate for DocumentReference.related");
                newResourceDetail.revisedResourceJson.related = editResourceState.related;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.related]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.author;
            if (editResourceState.author !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.author) &&
                !(!previousFinalValue && !editResourceState.author)) {
                //console.log("resourceUpdate for DocumentReference.author");
                newResourceDetail.revisedResourceJson.author = editResourceState.author;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.author]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.custodian;
            if (editResourceState.custodian !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.custodian) &&
                !(!previousFinalValue && !editResourceState.custodian)) {
                //console.log("resourceUpdate for DocumentReference.custodian");
                newResourceDetail.revisedResourceJson.custodian = editResourceState.custodian;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.custodian]);

    useEffect(() => {
        if (editResourceState) {
            const previousFinalValue = newResourceDetail.revisedResourceJson.description;
            if (editResourceState.description !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.description) &&
                !(!previousFinalValue && !editResourceState.description)) {
                //console.log("resourceUpdate for DocumentReference.description");
                newResourceDetail.revisedResourceJson.description = editResourceState.description;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            let previousFinalValue = newResourceDetail.revisedResourceJson.content;
            if (editResourceState.content !== undefined &&
                !jsonEquals(previousFinalValue, editResourceState.content) &&
                !(!previousFinalValue && !editResourceState.content)) {
                //console.log("resourceUpdate for DocumentReference.content");
                newResourceDetail.revisedResourceJson.content = editResourceState.content;
                dispatch(resourceUpdated(newResourceDetail));
            }
        }
    }, [editResourceState.content]);

    return <div style={{ marginTop: "12px" }}>
        <div style={{ marginLeft: "24px" }}>
            <StringEntry elementName='title' fieldLabel='Title'
                startingValue={extensionState.title}
                setResourceState={setExtensionState} />
            <CodeableConceptEntry elementName='type' fieldLabel='Type'
                startingValue={editResourceState.type}
                codeableConceptLevelValueSet={documentReferenceTypeValueSet}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="DocumentReferenceContent" elementName='content'
                fieldLabel='Content (as Attachment)'
                startingValue={editResourceState.content || []}
                setResourceState={setEditResourceState} />
            <CodeEntry elementName='status' fieldLabel='Resource status'
                startingValue={editResourceState.status || 'current'}
                allowedValues={['current', 'superseded', 'entered-in-error']}
                setResourceState={setEditResourceState} />
            <CodeEntry elementName='docStatus' fieldLabel='Document status'
                startingValue={editResourceState.docStatus}
                allowedValues={['registered', 'partial', 'preliminary', 'final', 'amended', 'corrected', 'appended', 'cancelled', 'entered-in-error', 'deprecated', 'unknown']}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel='Description'
                startingValue={editResourceState.description}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="CodeableConcept" elementName='category'
                fieldLabel='Category'
                startingValue={editResourceState.category || []}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Identifier" elementName='identifier'
                fieldLabel='Identifier'
                startingValue={editResourceState.identifier || []}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='version' fieldLabel='Version'
                startingValue={editResourceState.version}
                setResourceState={setEditResourceState} />
            <ReferenceEntry elementName='subject'
                fieldLabel='Subject'
                containedResourceDictionary={containedResourceDictionary}
                startingValue={editResourceState.subject || null}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Reference" elementName='related'
                fieldLabel='Related Item'
                startingValue={editResourceState.related || []}
                setResourceState={setEditResourceState} />
            <ArrayEntry datatype="Reference" elementName='author'
                fieldLabel='Author'
                referencedResourceTypes={["Practitioner", "PractitionerRole", "Organization", "Device", "Patient", "RelatedPerson", "CareTeam", "Group"]}
                startingValue={editResourceState.author || []}
                setResourceState={setEditResourceState} />
            <ReferenceEntry elementName='custodian'
                fieldLabel='Custodian' startingResourceType="Organization"
                containedResourceDictionary={containedResourceDictionary}
                startingValue={editResourceState.custodian || null}
                setResourceState={setEditResourceState} />
        </div>
    </div>
};

export default DocumentReferenceResourceEdit;